"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.javascriptLanguage = void 0;
var tsxLanguage_js_1 = require("./tsxLanguage.js");
exports.javascriptLanguage = __assign(__assign({}, tsxLanguage_js_1.tsxLanguage), { defaultSnippetTemplate: "\n{{ keyword }}('{{ expression }}', ({{ #parameters }}{{ #seenParameter }}, {{ /seenParameter }}{{ name }}{{ /parameters }}) => {\n  // {{ blurb }}\n})\n" });
//# sourceMappingURL=javascriptLanguage.js.map